import { IconType, SvgIcon } from './SvgIcon';

export const PlusIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M15.833 9.16732H10.833V4.16732C10.833 3.9463 10.7452 3.73434 10.5889 3.57806C10.4326 3.42178 10.2207 3.33398 9.99967 3.33398C9.77866 3.33398 9.5667 3.42178 9.41042 3.57806C9.25414 3.73434 9.16634 3.9463 9.16634 4.16732V9.16732H4.16634C3.94533 9.16732 3.73337 9.25512 3.57709 9.4114C3.42081 9.56768 3.33301 9.77964 3.33301 10.0007C3.33301 10.2217 3.42081 10.4336 3.57709 10.5899C3.73337 10.7462 3.94533 10.834 4.16634 10.834H9.16634V15.834C9.16634 16.055 9.25414 16.267 9.41042 16.4232C9.5667 16.5795 9.77866 16.6673 9.99967 16.6673C10.2207 16.6673 10.4326 16.5795 10.5889 16.4232C10.7452 16.267 10.833 16.055 10.833 15.834V10.834H15.833C16.054 10.834 16.266 10.7462 16.4223 10.5899C16.5785 10.4336 16.6663 10.2217 16.6663 10.0007C16.6663 9.77964 16.5785 9.56768 16.4223 9.4114C16.266 9.25512 16.054 9.16732 15.833 9.16732Z"
      fill="currentColor"
    />
  </SvgIcon>
);

PlusIcon.displayName = 'PlusIcon';
